import yaml from 'js-yaml';

export interface MediaItem {
  id?: string;
  label?: string;
  category?: string;
  notes?: string;
  src: string;
  type: 'image' | 'video';
  duration?: number; // ms (images only)
  skipCapture?: boolean;
  audio?: string; // optional audio to play when the item starts
  audioVolume?: number; // 0..1
}

export interface GalleryConfig {
  media: MediaItem[];
}

export async function loadGalleryConfig(): Promise<GalleryConfig> {
  const res = await fetch('/gallery-config.yaml');
  if (!res.ok) {
    throw new Error(`获取画廊配置失败：${res.statusText}`);
  }
  const text = await res.text();
  return yaml.load(text) as GalleryConfig;
}
